// extracted by mini-css-extract-plugin
export default {"main_Section":"input_main_Section__A5hA3","left_section":"input_left_section__QfCGa","right_section":"input_right_section__nzOvh"};